import React from 'react';
import parse from 'html-react-parser';
import {MUIAvatar, MUIBox, MUIGrid, MUITypography} from '@/components/MUI-Components';
import {dateConvertor} from '@/components/Common/dateconverter';
import {getInitials} from '@/utils/formatters';

// Comments list. The render guard (`commentData && commentData.length >= 1`) is
// preserved inside the component (returns null otherwise) so output is identical.
const BlogComments = ({commentData}: {commentData: any}) => {
    if (!(commentData && commentData.length >= 1)) return null;
    return (
        <>
            {commentData.map((item: any) => (
                <MUIGrid item xs={12} key={item.id}>
                    <MUIGrid container className="top-spacing margin">
                        <MUIGrid item xs={3} sm={1.5} md={1}>
                            <MUIAvatar className="blog-avatar comment-user">{getInitials(item.author_name)}</MUIAvatar>
                        </MUIGrid>
                        <MUIGrid item xs={8} sm={9} md={10}>
                            <MUIBox className="comment-user-name solutions left">
                                <MUITypography className="spectrum-heading color-black">{item.author_name}</MUITypography>
                                <MUITypography className="spectrum-sub-heading color-black">{dateConvertor(item.date)}</MUITypography>
                            </MUIBox>
                            <MUIBox className="comment-content">
                                <div className="comment-by-user">{item?.content?.rendered ? parse(item.content.rendered) : ''}</div>
                            </MUIBox>
                        </MUIGrid>
                    </MUIGrid>
                </MUIGrid>
            ))}
        </>
    );
};

export default BlogComments;
